/**
 *
 * Cycles through images. Fades in and out. Can include any number of images.
 *
 * Markup Example
 * sw--is-hidden gets added to all except for first img.
 *
 * <div data-sw-image-cycle>
     <div data-sw-image-cycle-image class="sw--position-absolute sw--height-full">
      <img src="https://static1.sw-cdn.net/files/cms/marketplace/jewelry/nautical-slides-ahoy-ring.gif" alt="Nautical Themed Jewelry" width="85%">
     </div>
     <div data-sw-image-cycle-image class="sw--is-hidden sw--position-absolute sw--height-full">
      <img src="https://static1.sw-cdn.net/files/cms/marketplace/jewelry/nautical-slides-coral-bracelet.gif" alt="Nautical Themed Jewelry" width="85%">
     </div>
     <div data-sw-image-cycle-image class="sw--is-hidden sw--position-absolute sw--height-full">
      <img src="https://static1.sw-cdn.net/files/cms/marketplace/jewelry/nautical-slides-shark-fin-ring.gif" alt="Nautical Themed Jewelry" width="85%">
     </div>
     <div data-sw-image-cycle-image class="sw--is-hidden sw--position-absolute sw--height-full">
      <img src="https://static1.sw-cdn.net/files/cms/marketplace/jewelry/nautical-slides-stingray-pendant.gif" alt="Nautical Themed Jewelry" width="85%">
     </div>
   </div>
 *
 */

var $ = require('./../sw-jquery');

var IMAGE_TIMEOUT = 3000;
var FADE_TIMEOUT = 1000;

module.exports = function($fragment) {

  $fragment.swFindWithSelf('[data-sw-image-cycle]').each(function() {
    var $el = $(this);

    // Options
    var imageTimeout = $el.data('swImageCycleTimeout') ? $el.data('swImageCycleTimeout') : IMAGE_TIMEOUT;
    var imageFade = $el.data('swImageCycleFade') ? $el.data('swImageCycleFade') : FADE_TIMEOUT;

    $el.find('[data-sw-image-cycle-image]:gt(0)').addClass('sw--is-hidden');

    setInterval(function() {
      $('[data-sw-image-cycle] > [data-sw-image-cycle-image]:first')
        .fadeOut(imageFade)
        .next()
        .fadeIn(imageFade)
        .end()
        .appendTo('[data-sw-image-cycle]');
    },  imageTimeout);
  });
};